import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorIcon from '@mui/icons-material/Error';
import { Tooltip, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { type GridColDef } from 'esseal-data-table';

import { type Schedule, ResourceScheduleStatusEnum } from '@/graphql/generated/graphql';
import { titleizeCamelCase, formatAddress } from '@/utils/helperFunctions';

const equipmentRegisterColumns = (timeFormat: string): GridColDef<Schedule>[] => [
  {
    field: 'companyResource',
    headerName: 'Name',
    width: 180,
    valueGetter: (row) => row.companyResource?.name ?? 'No Resource Assigned',
    renderCell: ({ row }) => {
      return row.companyResource ? `${titleizeCamelCase(row.companyResource.name)}` : 'No Resource Assigned';
    },
  },
  {
    field: 'startTime',
    headerName: 'Check In',
    width: 180,
    filterable: false,
    renderCell: (row) => dayjs(row.value).format(timeFormat),
  },
  {
    field: 'endTime',
    headerName: 'Check Out',
    width: 180,
    filterable: false,
    renderCell: (row) => dayjs(row.value).format(timeFormat),
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 180,
    filterable: false,
    renderCell: ({ value }) => {
      if (value === ResourceScheduleStatusEnum.Scheduled)
        return (
          <Tooltip title="Scheduled">
            <CheckCircleOutlineIcon sx={{ marginTop: '8px' }} color="success" fontSize="small" />
          </Tooltip>
        );
      if (value === ResourceScheduleStatusEnum.Dropped)
        return (
          <Tooltip title="Dropped">
            <CancelIcon sx={{ marginTop: '8px' }} color="error" fontSize="small" />
          </Tooltip>
        );
      if (value === ResourceScheduleStatusEnum.Missed)
        return (
          <Tooltip title="Missed">
            <ErrorIcon sx={{ marginTop: '8px' }} color="error" fontSize="small" />
          </Tooltip>
        );
      if (value === ResourceScheduleStatusEnum.Completed)
        return (
          <Tooltip title="Completed">
            <CheckCircleIcon sx={{ marginTop: '8px' }} color="success" fontSize="small" />
          </Tooltip>
        );
    },
  },
  {
    field: 'quantity',
    width: 180,
    headerName: 'Qty',
  },
  {
    field: 'source',
    width: 180,
    headerName: 'Source',
  },
  {
    field: 'address',
    headerName: 'Location',
    width: 180,
    valueGetter: (row) => (row.address ? (row.address?.title ?? 'Primary') : '-'),
    renderCell: ({ row, value }) => (
      <Tooltip title={formatAddress(row.address)}>
        <Typography variant="caption" noWrap sx={{ maxWidth: '400px' }}>
          {value}
        </Typography>
      </Tooltip>
    ),
  },
];

export default equipmentRegisterColumns;
